export default {
    CHANGE_LANG: 'changeLang',
    CHANGE_PAGE_TITLE: 'changePageTitle',
};
